import { mockDataUtil } from './mockDataUtil';
import { storeItemInventoryList } from '../mock/storeItemInventoryData';
import { API_ENDPOINTS } from '../utils/apiEndpoints';
import httpClient from './httpClient';
import {
  StoreItemInventory,
  StoreItemInventoryFilters,
  StoreItemInventoryPaginationParams,
  ApiResponse,
  StoreItemInventoryPaginatedResponse
} from '../types/store-item-inventory';
import { WHOLE_USE_MOCK } from './api';

class StoreItemInventoryService {
// 是否使用模拟数据
  async getMock(): Promise<boolean> {
    return true;
  }

  /**
   * 获取门店商品库存分页列表
   * @param filters 筛选条件
   * @param pagination 分页参数
   * @returns 分页的门店商品库存列表
   */
  async getStoreItemInventories(
    filters: StoreItemInventoryFilters,
    pagination: StoreItemInventoryPaginationParams
  ): Promise<ApiResponse<StoreItemInventoryPaginatedResponse<StoreItemInventory>>> {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      // Mock 数据过滤逻辑
      let filteredData = [...storeItemInventoryList];

      // 门店编码筛选
      if (filters.storeCode) {
        filteredData = filteredData.filter(item => 
          item.storeCode.toLowerCase().includes(filters.storeCode!.toLowerCase())
        );
      }

      // 货品编码筛选
      if (filters.itemCode) {
        filteredData = filteredData.filter(item => 
          item.itemCode.toLowerCase().includes(filters.itemCode!.toLowerCase())
        );
      }

      // 货主编码筛选
      if (filters.ownerCode) {
        filteredData = filteredData.filter(item => 
          item.ownerCode.toLowerCase().includes(filters.ownerCode!.toLowerCase())
        );
      }

      // 搜索关键词筛选
      if (filters.search) {
        const searchLower = filters.search.toLowerCase();
        filteredData = filteredData.filter(item =>
          item.storeCode.toLowerCase().includes(searchLower) ||
          item.itemCode.toLowerCase().includes(searchLower) ||
          item.storeName?.toLowerCase().includes(searchLower) ||
          item.itemName?.toLowerCase().includes(searchLower) ||
          item.ownerCode.toLowerCase().includes(searchLower)
        );
      }

      // 排序
      if (pagination.sortBy && pagination.sortOrder) {
        filteredData.sort((a, b) => {
          const field = pagination.sortBy!;
          let aVal = a[field as keyof StoreItemInventory];
          let bVal = b[field as keyof StoreItemInventory];
          
          // 处理数字和字符串排序
          if (typeof aVal === 'number' && typeof bVal === 'number') {
            return pagination.sortOrder === 'asc' ? aVal - bVal : bVal - aVal;
          } else {
            const aStr = String(aVal || '').toLowerCase();
            const bStr = String(bVal || '').toLowerCase();
            if (pagination.sortOrder === 'asc') {
              return aStr.localeCompare(bStr);
            } else {
              return bStr.localeCompare(aStr);
            }
          }
        });
      }

      // 分页
      const startIndex = (pagination.currentPage - 1) * pagination.pageSize;
      const endIndex = startIndex + pagination.pageSize;
      const paginatedData = filteredData.slice(startIndex, endIndex);

      const response = await mockDataUtil.mockPageRes(paginatedData, {
        currentPage: pagination.currentPage,
        totalCount: filteredData.length,
        pageSize: pagination.pageSize
      });

      return response as unknown as ApiResponse<StoreItemInventoryPaginatedResponse<StoreItemInventory>>;
    } else {
      // 真实 API 调用
      const requestBody = {
        ...filters,
        currentPage: pagination.currentPage,
        pageSize: pagination.pageSize,
        sortBy: pagination.sortBy,
        sortOrder: pagination.sortOrder
      };

      const res = await httpClient.post(API_ENDPOINTS.STORE_ITEM_INVENTORY.PAGE, requestBody);
      return res.data;
    }
  }
}

export const storeItemInventoryService = new StoreItemInventoryService();